<script lang="ts">
	import { goto } from '$app/navigation';
	import { page } from '$app/state';
	import { translateDynKey } from '$lib';
	import BigButton from '$lib/components/BigButton.svelte';
	import Title from '$lib/components/Title.svelte';
	import { m } from '$lib/paraglide/messages';

	const error = {
		title: translateDynKey(`errors.${page.status}.title`, m['errors.unknown.title']()),
		message: translateDynKey(`errors.${page.status}.message`, m['errors.unknown.message']()),
	};
</script>

<svelte:head>
	<title>{error.title}</title>
</svelte:head>

<div class="full-container mx-auto">
	<Title class="mb-2">
		{error.title}
	</Title>
	<p class="mb-2">{error.message}</p>
	<BigButton onclick={() => goto('/')} class="bg-blue-600 px-6 py-3 text-white">
		{m.continue_shopping()}
	</BigButton>
</div>
